import { graphql } from "~/gql";

export const GET_PHASES = graphql(/* GraphQL */ `
  query GetPhases($matterId: Float!) {
    getPhases(matterId: $matterId) {
      ...PhaseParts
    }
  }
`);
